import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RelatedProductList } from '../models/product/productListing.modal';
import { CustomerReviewModel, DeleteReviewItem, ReviewAdd, ReviewListing, ReviewUpdateItem, UploadFileModel } from '../models/review';
import { ApiService } from './Common/api.service';
import { LocalstorageService } from './Common/localstorage.service';
import { UrlHelperService } from './Common/urlhelper.service';

@Injectable({
  providedIn: 'root'
})
export class ReviewManagementService {

  constructor(private _api: ApiService, private httpClient: HttpClient, private localStorage: LocalstorageService) { }

  reviewListing(reviewListing: ReviewListing) {
    return this._api.post(UrlHelperService.ReviewListing, reviewListing);
  }

  addReviews(addReview: ReviewAdd) {
    return this._api.post(UrlHelperService.ReviewAdd, addReview);
  }

  adminReviewList(reviewListing: ReviewListing) {
    return this._api.post(UrlHelperService.AdminReviewListing, reviewListing);
  }

  getReviewsById(reviewsId) {
    return this._api.post(UrlHelperService.GetReviewList + reviewsId);
  }

  updateReviews(updateReviewsItem: ReviewUpdateItem) {
    return this._api.post(UrlHelperService.UpdateReviews, updateReviewsItem);
  }

  deleteReview(deleteReviews: DeleteReviewItem) {
    return this._api.post(UrlHelperService.deleteReviews, deleteReviews );
  }

  uploadImage(uploadFileModel: UploadFileModel) {
    let formData = new FormData();
    formData.append('file',  uploadFileModel.Image,uploadFileModel.Image.name);
    return this.httpClient.post(environment.apiUrl + UrlHelperService.uploadeReviewImage + uploadFileModel.Id, formData,{ headers: { 'Authorization': this.localStorage.getToken() } });
  }

  getReviewImage(getReviewsImgItem: DeleteReviewItem) {
    return this._api.post(UrlHelperService.getReviewsImg, getReviewsImgItem );
  }

  ReviewImageList(reviewId) {
    return this._api.post(UrlHelperService.shopReviewImageListing + reviewId);
  }

  customerReviewAdd(customerReviewModel: CustomerReviewModel) {
    return this._api.post(UrlHelperService.customerReviewEndPoint, customerReviewModel);
  }

  uploadCustomerImage(uploadFileModel: UploadFileModel) {
    let formData = new FormData();
    formData.append('file',  uploadFileModel.Image,uploadFileModel.Image.name);
    return this.httpClient.post(environment.apiUrl + UrlHelperService.uploadCustomerReviewImage + uploadFileModel.Id, formData);
  }
}
